import React, { useState } from 'react'
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import Slide from '@material-ui/core/Slide';
import Logo from './../../assets/images/lcg-logo@3x.png'
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import LanguageMenu from 'components/LanguageMenu';
import Hidden from '@material-ui/core/Hidden';
import languages from 'locales';
import { useSelector, useDispatch } from 'react-redux';
import Drawer from '@material-ui/core/Drawer';
import { useHistory, NavLink } from "react-router-dom";
import DrawerIcon from './../../assets/images/drawer-icon.png'
import DrawerCloseIcon from './../../assets/images/drawer-close-icon.png'
import GlobalActions from 'stores/global/actions';
import { Scene } from 'react-scrollmagic';
import { useLocation } from "react-router-dom";
import headerIcon from './../../assets/images/header-icon.png'
import secondMenuIcon from './../../assets/images/more-right-golden.png'
import { injectIntl } from 'react-intl'
const useStyles = makeStyles((theme) => ({
    root: {
        "& .app-bar": {
            left: "0px",
            width: "100vw",
            background: "transparent",
            boxShadow: "none",
            "&.version2": {
                background: "rgba(0,18,41,0.7)",
            }
        },
        "& .tool-bar": {
            width: "100%",
            maxWidth: "1400px",
            margin: "0px auto",
            justifyContent: "space-between",
            [theme.breakpoints.down('sm')]: {

            }
        },
        "& .logo": {
            cursor: "pointer",
            width: "120px",
            height: "35px"
        },
        "& .firstMenu": {
            whiteSpace: "nowrap",
            display: "flex",
            margin: "0px"
        },
        "& .firstMenu-group": {
            "&:hover": {
                "& .secondMenu": {
                    display: "block",
                    animationDuration: "0.6s",
                    animationName: "$fadeIn",
                    animationFillMode: "forwards"
                }
            }
        },
        "& .firstMenu-button": {
            fontSize: "16px",
            color: "#fff",
            "&.golden": {
                color: "#dab873"
            }
        },
        "& .secondMenu": {
            display: "none",
            position: "absolute",
            top: "52px",
            left: "16px",
            padding: "10px",
            borderRadius: "4px",
            backgroundColor: "#fff",
            opacity: "0",
            "&.golden": {
                backgroundColor: "#dab873"
            },
            "&.active": {
                display: "block",
                animationDuration: "0.6s",
                animationName: "$fadeIn",
                animationFillMode: "forwards"
            }
        },
        "& .secondMenu-group": {
            alignItems: "flex-start",
            flexDirection: "column",
            padding: 0
        },
        "& .secondMenu-button": {
            whiteSpace: "nowrap",
            width: "100%",
            fontSize: "16px",
            color: "#001229",
            justifyContent: "left",
            padding: "8px 24px",
            "&.golden": {
                color: "#001229",
            },
        },
        "& .secondMenu-icon": {
            width: "15px",
            height: "10px",
            marginLeft: "8px"
        },
        "& .thirdMenu": {
            padding: 0,
            width: "100%",
        },
        "& .thirdMenu-item": {
            padding: 0
        },
        "& .thirdMenu-button": {
            width: "100%",
            whiteSpace: "nowrap",
            fontSize: "16px",
            color: "rgba(0,18,41,0.7)",
            justifyContent: "left",
            padding: "8px 24px"
        },
        "& .drawer-button": {
            minWidth: "48px",
            height: "48px",
            borderRadius: "50%",
            color: "#fff"
        },
        "& .drawer-icon": {
            height: "24px",
            width: "24px"
        },
        "& .MuiListItem-button": {
            fontWeight: "500",
            borderRadius: "4px",
            position: "relative",
            "&:hover": {
                color: "#dab873"
            },
            "&.spacial": {
                color: "#dab873"
            },
            "&.actived": {
                outline: "none",
                "&:after": {
                    position: "absolute",
                    content: "''",
                    display: "block",
                    width: "calc(100% - 32px)",
                    height: "4.4px",
                    backgroundImage: `url(${headerIcon})`,
                    backgroundSize: 'cover',
                    bottom: "-2px",
                    left: "16px"
                }
            }
        },

    },
    languageBox: {
        padding: "8px 16px",
        whiteSpace: "nowrap",
        "& button": {
            padding: "8px 16px",
            fontWeight: "400"
        }
    },
    drawer: {
        "& .logo": {
            cursor: "pointer",
            width: "120px",
            height: "35px"
        },
        "& .MuiDrawer-paper": {
            width: "100%",
            maxWidth: "375px",
            backgroundColor: "rgb(0,19,36)",
            color: "#ffffff"
        },
        "& .drawer-header": {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "8px 16px",
        },
        "& .drawer-button-close": {
            color: "#fff",
            "& img": {
                width: "24px",
                height: "24px"
            }
        },
        "& .MuiList-padding": {
            padding: "30px 0px"
        },
        "& .MuiListItem-button": {
            justifyContent: "center",
            color: "#fff",
            padding: "16px",
            fontSize: "18px",
            "&:hover": {
                backgroundColor: "rgba(255,255,255,0.1)"
            },
            "& a": {
                color: "white",
                padding: "14px 22px 14px 32px"
            },
            "&.spacial": {
                color: "#dab873"
            },
        },
        "& .language-button": {
            fontSize: "14px",
            padding: "0px",
            margin: "12px auto",
            width: "fit-content",
            "&.Mui-disabled": {
                borderBottom: "1px solid #fff",
                opacity: "1"
            },
        },
    },
    "@keyframes fadeIn": {
        "0%": {
            transform: "translate(0px,-10%)",
            opacity: "0"
        },
        "100%": {
            transform: "translate(0px,0%)",
            opacity: "1"

        }
    },
}))
function HideOnScroll(props: any) {
    const { children, window } = props;
    const trigger = useScrollTrigger({ target: window ? window() : undefined });
    return (
        <Slide appear={false} direction="down" in={!trigger}>
            {children}
        </Slide>
    );
}

HideOnScroll.propTypes = {
    children: PropTypes.element.isRequired,
    window: PropTypes.func,
};

const Header = (props: any) => {
    const { intl } = props
    const classes = useStyles()
    const history = useHistory();
    const dispatch = useDispatch()
    const { pathname } = useLocation();
    const [drawerOpen, setDrawerOpen] = useState(false)

    const global = useSelector((state: any) => state.global);
    const selectedIndex = languages[global.locale].id;

    const onChangeLanguage = (action: any) => {
        dispatch(GlobalActions.changeLanguage(action))
        setDrawerOpen(false)
    }

    const toggleDrawer = () => {
        setDrawerOpen((drawerOpen: any) => !drawerOpen)
    }
    const handleFocus = (e: any) => {
        e.currentTarget.children[1].classList.add("active")
        if (e.currentTarget === e.target) {
        } else {
        }
        if (!e.currentTarget.contains(e.relatedTarget)) {
            // Not triggered when swapping focus between children
        }
    }
    const handleBlur = (e: any) => {
        if (!e.currentTarget.contains(e.relatedTarget)) {
            e.currentTarget.classList.remove("active")
        }
    }

    return (
        <Scene classToggle={[".app-bar", "version2"]} offset={20} triggerHook="onLeave" triggerElement=".headerTarget">
            <div className={`${classes.root} headerTarget`}>
                <CssBaseline />
                <HideOnScroll {...props}>
                    <AppBar className="app-bar">
                        <Toolbar className="tool-bar">
                            <nav>
                                <List className="firstMenu" >
                                    <ListItem>
                                        <NavLink to="/">
                                            <img className="logo" src={Logo} alt="leadbest-logo" />
                                        </NavLink>
                                    </ListItem>
                                    <Hidden smDown>
                                        <ListItem className="firstMenu-group" >
                                            <Button className="firstMenu-button" >
                                                {intl.formatMessage({ id: "header.menu.1" })}
                                            </Button>
                                            <List className="secondMenu" >
                                                <ListItem className="secondMenu-group">
                                                    <Button className="secondMenu-button" component={NavLink} to='/about'>
                                                        {intl.formatMessage({ id: "header.menu.1.1" })}
                                                        <img className="secondMenu-icon" src={secondMenuIcon} alt="" />
                                                    </Button>
                                                    <List className="thirdMenu">
                                                        <ListItem className="thirdMenu-item">
                                                            <Button className="thirdMenu-button" component={NavLink} to='/about#team' >
                                                                {intl.formatMessage({ id: "header.menu.1.1.1" })}
                                                            </Button>
                                                        </ListItem>
                                                        <ListItem className="thirdMenu-item">
                                                            <Button className="thirdMenu-button" component={NavLink} to='/about#bulletin'>
                                                                {intl.formatMessage({ id: "header.menu.1.1.2" })}
                                                            </Button>
                                                        </ListItem>
                                                        <ListItem className="thirdMenu-item">
                                                            <Button className="thirdMenu-button" component={NavLink} to='/about#timeline'>
                                                                {intl.formatMessage({ id: "header.menu.1.1.3" })}
                                                            </Button>
                                                        </ListItem>
                                                    </List>
                                                </ListItem>
                                                {/* 集團理念 暫時隱藏 */}
                                                <ListItem className="secondMenu-group">
                                                    <Button className="secondMenu-button" component={NavLink} to='/scribing'>
                                                        {intl.formatMessage({ id: "header.menu.1.2" })}
                                                        <img className="secondMenu-icon" src={secondMenuIcon} alt="" />
                                                    </Button>
                                                    <List className="thirdMenu">
                                                        <ListItem className="thirdMenu-item">
                                                            <Button className="thirdMenu-button" component={NavLink} to='/scribing#drawing'>
                                                                {intl.formatMessage({ id: "header.menu.1.2.1" })}
                                                            </Button>
                                                        </ListItem>
                                                        <ListItem className="thirdMenu-item">
                                                            <Button className="thirdMenu-button" component={NavLink} to='/scribing#organization'>
                                                                {intl.formatMessage({ id: "header.menu.1.2.2" })}
                                                            </Button>
                                                        </ListItem>
                                                    </List>
                                                </ListItem>
                                            </List>
                                        </ListItem>
                                        <ListItem className="firstMenu-group">
                                            <Button className="firstMenu-button" >
                                                {intl.formatMessage({ id: "header.menu.2" })}
                                            </Button>
                                            <List className="secondMenu" >
                                                <ListItem className="secondMenu-group">
                                                    <Button className="secondMenu-button" component={NavLink} to='/service'>
                                                        {intl.formatMessage({ id: "header.menu.2.1" })}
                                                        <img className="secondMenu-icon" src={secondMenuIcon} alt="" />
                                                    </Button>
                                                    <List className="thirdMenu">
                                                        <ListItem className="thirdMenu-item">
                                                            <Button className="thirdMenu-button" component={NavLink} to='/service#step' >
                                                                {intl.formatMessage({ id: "header.menu.2.1.1" })}
                                                            </Button>
                                                        </ListItem>
                                                        {/* <ListItem className="thirdMenu-item">
                                                            <Button className="thirdMenu-button" component={NavLink} to='/service#vonage'>
                                                                {intl.formatMessage({ id: "header.menu.2.1.2" })}
                                                            </Button>
                                                        </ListItem> */}
                                                        <ListItem className="thirdMenu-item">
                                                            <Button className="thirdMenu-button" component={NavLink} to='/service#google'>
                                                                {intl.formatMessage({ id: "header.menu.2.1.3" })}
                                                            </Button>
                                                        </ListItem>
                                                        <ListItem className="thirdMenu-item">
                                                            <Button className="thirdMenu-button" component={NavLink} to='/empower/web3-business-consulting-service'>
                                                                {intl.formatMessage({ id: "header.menu.2.1.4" })}
                                                            </Button>
                                                        </ListItem>
                                                        <ListItem className="thirdMenu-item">
                                                            <Button className="thirdMenu-button" component={NavLink} to='/empower/cybersecurity-consulting-service'>
                                                                {intl.formatMessage({ id: "header.menu.2.1.5" })}
                                                            </Button>
                                                        </ListItem>
                                                        <ListItem className="thirdMenu-item">
                                                            <Button className="thirdMenu-button" component={NavLink} to='/empower/design-empowerment-consulting-services'>
                                                                {intl.formatMessage({ id: "header.menu.2.1.6" })}
                                                            </Button>
                                                        </ListItem>
                                                    </List>
                                                </ListItem>
                                            </List>
                                        </ListItem>
                                        <ListItem className="firstMenu-group">
                                            <Button className="firstMenu-button" >
                                                {intl.formatMessage({ id: "header.menu.3" })}
                                            </Button>
                                            <List className="secondMenu">
                                                <ListItem className="secondMenu-group">
                                                    <Button className="secondMenu-button" component={NavLink} to='/empower?category=ALL&page=1'>
                                                        {intl.formatMessage({ id: "header.menu.3.1" })}
                                                        <img className="secondMenu-icon" src={secondMenuIcon} alt="" />
                                                    </Button>
                                                    <List className="thirdMenu">
                                                        <ListItem className="thirdMenu-item">
                                                            <Button className="thirdMenu-button" component={NavLink} to='/empower?category=DIGITAL_EMPOWERMENT&page=1&anchor=true' >
                                                                {intl.formatMessage({ id: "header.menu.3.1.1" })}
                                                            </Button>
                                                        </ListItem>
                                                        <ListItem className="thirdMenu-item">
                                                            <Button className="thirdMenu-button" component={NavLink} to='/empower?category=VENTURE_CAPITAL&page=1&anchor=true'>
                                                                {intl.formatMessage({ id: "header.menu.3.1.2" })}
                                                            </Button>
                                                        </ListItem>
                                                    </List>
                                                </ListItem>
                                            </List>
                                        </ListItem>
                                        <ListItem className="firstMenu-group">
                                            <Button className="firstMenu-button" >
                                                {intl.formatMessage({ id: "header.menu.4" })}
                                            </Button>
                                            <List className="secondMenu" >
                                                <ListItem className="secondMenu-group">
                                                    <Button className="secondMenu-button" component={NavLink} to='/news?type=ALL&page=1'>
                                                        {intl.formatMessage({ id: "header.menu.4.1" })}
                                                        <img className="secondMenu-icon" src={secondMenuIcon} alt="" />
                                                    </Button>
                                                    <List className="thirdMenu">
                                                        <ListItem className="thirdMenu-item">
                                                            <Button className="thirdMenu-button" component={NavLink} to='/news?type=NEWS&page=1&anchor=true' >
                                                                {intl.formatMessage({ id: "header.menu.4.1.1" })}
                                                            </Button>
                                                        </ListItem>
                                                        <ListItem className="thirdMenu-item">
                                                            <Button className="thirdMenu-button" component={NavLink} to='/news?type=ARTICLE&page=1&anchor=true'>
                                                                {intl.formatMessage({ id: "header.menu.4.1.2" })}
                                                            </Button>
                                                        </ListItem>
                                                    </List>
                                                </ListItem>
                                            </List>
                                        </ListItem>
                                        <ListItem className="firstMenu-group">
                                            <Button className="firstMenu-button" component={NavLink} to='/join'>
                                                {intl.formatMessage({ id: "header.menu.5" })}
                                            </Button>
                                        </ListItem>
                                        <ListItem className="firstMenu-group">
                                            <Button className="firstMenu-button" component={NavLink} to='/contact'>
                                                {intl.formatMessage({ id: "header.menu.6" })}
                                            </Button>
                                        </ListItem>
                                        <ListItem className="firstMenu-group">
                                            <Button className="firstMenu-button golden"  >
                                                {intl.formatMessage({ id: "header.menu.7" })}
                                            </Button>
                                            <List className="secondMenu golden" >
                                                {/* 外部連結要加 pathname */}
                                                <ListItem className="secondMenu-group">
                                                    <Button className="secondMenu-button golden" component={NavLink} to={{ pathname: (global.locale == 'zh_tw') ? "https://www.echox.app/zh-hant/" : "https://www.echox.app/" }} target="_blank">
                                                        {intl.formatMessage({ id: "header.menu.7.4" })}
                                                    </Button>
                                                </ListItem>
                                                <ListItem className="secondMenu-group">
                                                    <Button className="secondMenu-button golden" component={NavLink} to={{ pathname: "https://www.leadagilex.com/" }} target="_blank">
                                                        {intl.formatMessage({ id: "header.menu.7.2" })}
                                                    </Button>
                                                </ListItem>
                                                <ListItem className="secondMenu-group">
                                                    <Button className="secondMenu-button golden" component={NavLink} to={{ pathname: "https://www.presurgmedia.com/" }} target="_blank">
                                                        {intl.formatMessage({ id: "header.menu.7.5" })}
                                                    </Button>
                                                </ListItem>
                                                {/* 暫時隱藏 */}
                                                {/* <ListItem className="secondMenu-group">
                                                    <Button className="secondMenu-button golden" component={NavLink} to='#'>
                                                        {intl.formatMessage({ id: "header.menu.7.3" })}
                                                    </Button>
                                                </ListItem> */}
                                            </List>
                                        </ListItem>

                                    </Hidden>

                                </List>
                            </nav>
                            <Hidden only={["lg", "md", "xl"]}>
                                <Button aria-label="drawer" className="drawer-button" onClick={toggleDrawer}>
                                    <img className="drawer-icon" src={DrawerIcon} alt="drawer-icon" />
                                </Button>
                            </Hidden>
                            <Hidden smDown>
                                {
                                    Object.keys(languages).length > 1 &&
                                    <Box className={classes.languageBox} >
                                        {
                                            global.languageSettings.isInitial &&
                                            <LanguageMenu color="#fff" />
                                        }
                                    </Box>
                                }
                            </Hidden>
                            <Drawer className={classes.drawer} anchor={"left"} open={drawerOpen} onClose={toggleDrawer}>
                                <div className="drawer-header">
                                    <img className="logo" src={Logo} alt="leadbest-logo" onClick={() => history.push('/')} />

                                    <IconButton aria-label="drawer" className="drawer-button-close" onClick={toggleDrawer}>
                                        <img src={DrawerCloseIcon} alt="drawer-icon-image" />
                                    </IconButton>
                                </div>
                                <List>
                                    <ListItem button onClick={() => history.push('/about')}>
                                        {intl.formatMessage({ id: "header.drawer.1" })}
                                    </ListItem>
                                    <ListItem button onClick={() => history.push('/scribing')}>
                                        {intl.formatMessage({ id: "header.drawer.2" })}
                                    </ListItem>
                                    <ListItem button onClick={() => history.push('/service')}>
                                        {intl.formatMessage({ id: "header.drawer.3" })}
                                    </ListItem>
                                    <ListItem button onClick={() => history.push('/empower?page=1&category=ALL')}>
                                        {intl.formatMessage({ id: "header.drawer.4" })}
                                    </ListItem>
                                    <ListItem button onClick={() => history.push('/news?page=1&type=ALL')}>
                                        {intl.formatMessage({ id: "header.drawer.5" })}
                                    </ListItem>
                                    <ListItem button onClick={() => history.push('/join')}>
                                        {intl.formatMessage({ id: "header.drawer.6" })}
                                    </ListItem>
                                    <ListItem button onClick={() => history.push('/contact')}>
                                        {intl.formatMessage({ id: "header.drawer.7" })}
                                    </ListItem>
                                    <a href="https://www.leadagilex.com/" target="_blank" rel="noreferrer noopener">
                                        <ListItem className="spacial" button style={{ marginBottom: "32px" }}>
                                            {intl.formatMessage({ id: "header.drawer.8" })}
                                        </ListItem>
                                    </a>
                                    {Object.keys(languages).map((key: any, index: any) => {
                                        const item: any = languages[key];
                                        return (
                                            <ListItem button
                                                className="language-button"
                                                key={index}
                                                disabled={index === selectedIndex}
                                                selected={index === selectedIndex}
                                                onClick={() => onChangeLanguage({ locale: item.locale })}
                                            >
                                                {item.label}
                                            </ListItem>
                                        )
                                    })}
                                </List>
                            </Drawer>

                        </Toolbar>
                    </AppBar>
                </HideOnScroll>
            </div>
        </Scene>
    )
}
export default injectIntl(Header);